/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";

/**
 * Press the enter button  
 */
window.$("#loginForm").keyup(function (event) {
    if (event.which === 13) {
        window.$(".login_btn").click();
    }
});

/**
 * Admin Login 
 */

window.$(".login_btn").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.axios({
        method: "post",
        url: window.$("#loginForm").attr('action'),
        data: window.$("#loginForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            window.location = response.data.redirectTo;
        })
        .catch(function (error) {
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Employee store 
 */
window.$(".saveEmployee").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveEmployee').attr('disabled', 'disabled');
    var code = $(".iti__selected-dial-code");
    window.axios({
        method: "post",
        url: window.$(".employeeForm").attr('action'),
        data: window.$(".employeeForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function (error) {
            window.$('.saveEmployee').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Employee update 
 */
window.$(".updateEmployee").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateEmployee').attr('disabled', 'disabled');
    var code = $(".iti__selected-dial-code");
    window.axios({
        method: "PUT",
        url: window.$(".employeeUpdateForm").attr('action'),
        data: window.$(".employeeUpdateForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function (error) {
            window.$('.updateEmployee').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Employee table listing 
 */

var table = window.$('.employeeTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".employeeTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false, },
        { data: 'first_name', name: 'first_name' },
        { data: 'last_name', name: 'last_name' },
        { data: 'email', name: 'email' },

        { data: 'position', name: 'position' },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ]
});

/**
 * Employee Delete 
 */
window.$(document).on('click', '.deleteEmployee', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".employeeTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".employeeTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        console.log(err);
        return false;
    });

});

// Serach in dataTable
window.$(document).ready(function () {
    // Setup - add a text input to each footer cell
    var excluded_columns = [6];
    searchByTableColumns(table, '.employeeTable', excluded_columns);
    window.$("#employee-position").on('change', function (e) {

        if (window.$(this).val() == 'staff') {
            window.$("#label-email").closest('div').hide();
        } else {
            window.$("#label-email").closest('div').show();
        }

    });
});

/**
 * Restaurant Owner update 
 */
window.$(".updateRestaurantOwner").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateRestaurantOwner').attr('disabled', 'disabled');
    window.axios({
        method: "PUT",
        url: window.$(".restaurantOwnerForm").attr('action'),
        data: window.$(".restaurantOwnerForm").serialize(),
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function (error) {
            window.$('.updateRestaurantOwner').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    console.log(value[0])
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 401 || error.response.status == 403) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

window.$(".password_change").on('click', function (e) {
    if ($(this).is(":checked")) {
        $(".password_block").removeClass('d-none');
    } else {
        $(".password_block").addClass('d-none');
    }
});
window.$(".ShowPassWord").on('click', function (e) {
    var x = document.getElementById("password");
    var show_eye = document.getElementById("show_eye");
    var hide_eye = document.getElementById("hide_eye");
    hide_eye.classList.remove("d-none");
    if (x.type === "password") {
        x.type = "text";
        show_eye.style.display = "none";
        hide_eye.style.display = "block";

    } else {
        x.type = "password";
        show_eye.style.display = "block";
        hide_eye.style.display = "none";

    }
});